import React from "react";
import { useLocation } from "react-router";
import ElasticService from "src/services/elasticService";
import { useSelector } from "src/store";
import { Header } from "src/ui/shared/table/TableHeader";

import { Group } from "@dashboard/devices/types";
import { selectGroups } from "@dashboard/groups/store/selectors";
import { FilterBadge } from "@shared/CustomBadge";
import { Header as TanstackHeader, Table } from "@tanstack/react-table";

import { GroupFilterModal } from "../GroupFilterModal";

import { getInitialFilters } from "./GroupFilterHeader.utils";

export type GroupWithChildren = Group & {
    children: GroupWithChildren[];
};
type FormValues = {
    [key: string]: boolean;
};
type Props<T> = {
    badgeContent: number;
    table: Table<T>;
    header: TanstackHeader<T, unknown>;
    onSubmit: (values: FormValues) => void;
    isOpen?: boolean;
};
export const GroupFilterHeader = <T,>(props: Props<T>) => {
    const [open, setOpen] = React.useState(!!props.isOpen);

    const location = useLocation();

    const allGroups = useSelector(selectGroups);
    const initialValues = getInitialFilters(props.table, allGroups, props.header.id);

    const onOpen = () => {
        setOpen(true);

        ElasticService.createTransaction("groupFilter", {
            page: location.pathname,
        });
    };

    return (
        <Header {...props.header}>
            <FilterBadge badgeContent={props.badgeContent} onClick={onOpen} />
            <GroupFilterModal
                open={open}
                initialValues={initialValues}
                onSubmit={props.onSubmit}
                setOpen={setOpen}
            />
        </Header>
    );
};
